import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DMUSelectionService {

  private selectedOptionsSubject = new BehaviorSubject<string[]>([]);
  selectedSeries$ = new BehaviorSubject<any[]>([]);
  selectedOptions$ = this.selectedOptionsSubject.asObservable();
  

  updateSelectedOptions(options: string[]) {
    this.selectedOptionsSubject.next(options);
  }

  updateSeries(options: string[]) {
    this.selectedSeries$.next(options);
  }
  
  
}
